export default __webpack_public_path__ + "static/media/480_private01-jp-web.792fe452.png";